import React from "react";
import { makeStyles } from "@mui/styles";
import { Avatar, Card, IconButton, Tooltip, Typography } from "@mui/material";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { alpha, useTheme } from "@mui/material/styles";
import {PRIMARY_COLOR_DarkNavyBlue, PRIMARY_COLOR_MediumRoyalBlue, WHITE} from "../../../constants/Colors";
import ConfirmationDialog from "../../../general_components/ConformationDialog";

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: 0,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "150px",
    display: "block",
    overflow: "hidden",
  },
  text: {
    opacity: 0.8,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "150px",
    display: "block",
    overflow: "hidden",
  },
  buttonContainer: {
    position: "absolute",
    top: 0,
    right: 0,
  },
}));

export default function AdminCard({ data, index, handleDelete, setOpenDel, load, openDel, setClickedAdminId}) {
  const classes = useStyles();
  const theme = useTheme();
  const [show, setShow] = React.useState(-1);

  return (
    <>
      <Card
        sx={{
          // mt: 4,
          py: 3,
          boxShadow: 0,
          borderRadius: 5,
          textAlign: "center",
          position: "relative",
          color: WHITE,
          bgcolor: PRIMARY_COLOR_MediumRoyalBlue,
          backgroundImage: (theme) =>
            `linear-gradient(110deg, ${alpha(
              PRIMARY_COLOR_MediumRoyalBlue,
              0.1
            )} 70%, ${alpha("#FFF", 0.34)} 100%)`,
        }}
        onMouseOver={() => setShow(index)}
        onMouseLeave={() => setShow(-1)}
      >
        <div className={classes.buttonContainer}>
          {!(show === index) ? null : (
            <Tooltip title="Delete">
              <IconButton
                onClick={() => {
                  setClickedAdminId(data.userId); setOpenDel(true);
                }}
              >
                <DeleteRoundedIcon sx={{ color: "#fff" }} />
              </IconButton>
            </Tooltip>
          )}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar
            sx={{
              width: 50,
              height: 50,
              marginBottom: 2,
              color: "#e1e1e1",

              backgroundImage: (theme) =>
                `linear-gradient(150deg, ${alpha(
                  PRIMARY_COLOR_DarkNavyBlue,
                  2
                )} 2%, ${alpha(PRIMARY_COLOR_DarkNavyBlue, 0.24)} 90%)`,
            }}
            src={""}
          />
          <Typography
            variant={"body1"}
            sx={{ fontWeight: 700 }}
            className={classes.title}
          >
            {data.name}
          </Typography>
          <Typography variant={"body2"} className={classes.text}>
            {data.email}
          </Typography>
          <Typography variant="subtitle2" sx={{ opacity: 0.72, paddingTop: 2 }}>
            {data.role === "Super_Admin"? "Super Admin":"Admin"}
          </Typography>
        </div>
      </Card>
      <ConfirmationDialog
        loading={load}
        open={openDel}
        close={setOpenDel}
        confirm={handleDelete}
        title="Confirmation"
        message="Are you sure you want to delete this?"
        cancelBtnText="Cancel"
        confirmBtnText="Delete"
        pageName="admin"
      />
    </>
  );
}
